
import { OioInputNumber, OioInputNumberProps } from '@kunlun/vue-ui-antd';
import { defineComponent } from 'vue';
import { OioCommonProps, OioMetadataProps, PreSuffixProps } from '@kunlun/dependencies';
import { useNumberProps } from './use-number-props';
import { removeDecimalZero } from '../../../../utils/number';

export default defineComponent({
  name: 'DefaultFloat',
  components: {
    OioInputNumber
  },
  inheritAttrs: false,
  props: {
    ...OioInputNumberProps,
    ...OioCommonProps,
    ...OioMetadataProps,
    ...PreSuffixProps,
    min: {
      type: [Number, String]
    },
    max: {
      type: [Number, String]
    },
    precision: {
      type: Number,
      default: 2
    },
    _formData: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    return {
      ...useNumberProps(props),
      removeDecimalZero
    };
  }
});
